import { useEffect, useState } from "react";

export default function AnimatedCounter({ value, duration = 800 }) {
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    const start = display;
    const end = value;
    const diff = end - start;
    const startTime = performance.now();

    const animate = (time) => {
      const t = Math.min((time - startTime) / duration, 1);
      const eased = t * (2 - t); // easeOutQuad
      setDisplay(Math.floor(start + diff * eased));

      if (t < 1) requestAnimationFrame(animate);
    };

    requestAnimationFrame(animate);
  }, [value]);

  return <span>{display.toLocaleString()}</span>;
}
